<template>
  <v-col>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text>
            <strong>Payment Status :</strong>
            <template v-if="payment.status">
              <v-chip
                class="ma-2"
                color="success"
                label
                text-color="white"
              >
                <v-icon left>
                  mdi-check-circle
                </v-icon>
                PAID
              </v-chip>
            </template>
            <template v-else>
              <v-chip
                class="ma-2"
                color="error"
                label
                text-color="white"
              >
                <v-icon left>
                  mdi-timer-sand
                </v-icon>
                Pending
              </v-chip>
            </template>
          </v-card-text>
        </v-card>
        <v-card
          outlined
          class="mt-3"
        >
          <v-card-text>
            <div>Payment Information</div>
          </v-card-text>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Method
                  </th>
                  <th class="text-left">
                    Type
                  </th>
                  <th class="text-left">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ payment.method ? "Live" : "Due" }}</td>
                  <td>{{ payment.type ? "Credit" : "Debit" }}</td>
                  <td>{{ payment.amount | currency }}</td>
                </tr>
                <template v-if="!payment.method && !payment.status">
                  <tr class="red--text active">
                    <td>
                      Due Date
                    </td>
                    <td colspan="2">
                      {{ order.dueDate }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        <v-card
          outlined
          class="mt-3"
        >
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <th class="text-left">
                      Payment At
                    </th>
                    <td>{{ payment.updated_at }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Gateway
                    </th>
                    <td>{{ payment.gateway | uppercase }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Payment Note
                    </th>
                    <td>{{ payment.note | capitalize }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text>
            <v-btn
              class=""
              @click="$router.back()"
            >
              Back
            </v-btn>
          </v-card-text>
          <v-card-text>
            <div>Order Information</div>

            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <template v-if="order.purchasing">
                      <th class="text-left info">
                        Purchase Reference
                      </th>
                      <td>
                        <v-icon
                          @click="
                            $router.push({
                              name: 'PurchaseTransactionDetails',
                              params: { id: order.id },
                            })
                          "
                        >
                          mdi-link
                        </v-icon>
                        {{ order.reference | uppercase }}
                      </td>
                    </template>
                    <template v-if="order.salling">
                      <th class="success">
                        #Sale Order
                      </th>
                      <td>
                        <v-icon
                          @click="
                            $router.push({
                              name: 'SaleDetail',
                              params: { id: order.id },
                            })
                          "
                        >
                          mdi-link
                        </v-icon>
                        {{ order.key }}
                      </td>
                    </template>
                    <template v-if="order.refunding">
                      <th class="red">
                        #Sale Refund Order
                      </th>
                      <td>
                        <v-icon
                          @click="
                            $router.push({
                              name: 'RefundDetail',
                              params: { id: order.id },
                            })
                          "
                        >
                          mdi-link
                        </v-icon>
                        {{ order.key }}
                      </td>
                    </template>
                  </tr>

                  <tr class="white">
                    <td colspan="2">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img
                            v-bind="attrs"
                            :src="order.barcode"
                            lazy-src="/storage/default_img/no_image.png"
                            aspect-ratio="1"
                            max-width="200"
                            max-height="25"
                            v-on="on"
                          />
                        </template>
                        <span>TRX #{{ order.key }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      - Discount Rate {{ order.discountRate }}%
                    </th>
                    <td>{{ order.discountedAmount | currency }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      + Tax Rate {{ order.taxRate }}%
                    </th>
                    <td>{{ order.taxAmount | currency }}</td>
                  </tr>
                  <tr>
                    <th class="text-left">
                      Total Amount
                    </th>
                    <td>{{ order.totalAmount | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      payment: {},
      order: {},
      form: {
        gateway: "cash",
      },
      gateways: ["card", "cheque", "cash", "other"],
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getFromApi();
    }
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    getFromApi() {
      window.axios.get("/payment/" + this.$route.params.id).then((response) => {
        this.$data.payment = response.data.payment;
        this.$data.order = response.data.payment.order;
      });
    },
    payNow() {
      window.axios
        .post("/make-payment/" + this.$route.params.id, this.$data.form)
        .then((response) => {
          this.feedback(response.data.message);
          this.getFromApi();
        });
    },
  },
};
</script>
